export enum MerchantRegistrationType {
  Sdk_Pline = 1,
  Terminal_Qd = 2,
  Coalition_Flow = 3,
}
